import LogRocket from 'logrocket';
import phioActionTypes from './phioActionTypes';
import { PhioState, PhioReducerAction } from './phioRedux.types';

export const initialPhioState: PhioState = {
    auth: null,
    regionData: {
        region: null,
        databaseId: null,
    },
    patient: null,
    platformProvider: null,
    isFirstAttempt: true,
    memberData: null,
};

export const phioReducer = (
    state = initialPhioState,
    action: PhioReducerAction,
): PhioState => {
    switch (action.type) {
        case phioActionTypes.SET_AUTH_STATE:
            return {
                ...state,
                auth: action.payload,
            };
        case phioActionTypes.SET_REGION:
            return {
                ...state,
                regionData: action.payload,
            };
        case phioActionTypes.SET_PATIENT_DATA: {
            const { payload } = action;
            if (payload && payload.patient_id) {
                LogRocket.identify(payload.patient_id);
            }
            return {
                ...state,
                patient: payload,
            };
        }
        case phioActionTypes.SET_IS_FIRST_ATTEMPT: {
            return {
                ...state,
                isFirstAttempt: action.payload,
            };
        }
        case phioActionTypes.SET_MEMBERSHIP:
            return {
                ...state,
                memberData: action.payload,
            };
        case phioActionTypes.RESET_PHIO_REDUCER: {
            return { ...initialPhioState };
        }
        default:
            return state;
    }
};
